import $        from 'jquery';
import template from './template.hbs';
import extend   from '../../util/extend';
import cookie   from '../../util/cookie';
import Step     from '../../classes/step';

const ebb     = [ 'tag:connect-non-bulk', 'tag:connect-non-bulk-hacla' ];
const has_tag = ( p, t ) => p.metadata && p.metadata.hasOwnProperty( t );

export default new Step({
  $el: $('<div class="form-step step-signup-confirmation" />'),
  template,
  render( state ) {
    const medium        = cookie.getItem('utm_medium');
    const kiosk         = medium === 'kiosk';
    const user_id       = state.user_id;
    const ebb_url       = `${ window.starry_com_url }/ebb/${ user_id }`;
    const plans         = window.plans || [];
    const ebb_qualified = ebb.some( t => plans.some( p => has_tag( p, t ) ) );

    const ext = extend( {}, state, { kiosk, ebb_qualified, ebb_url } );

    if ( kiosk ) {
      setTimeout( () => window.location = '/', 5000 );
    }

    return Step.prototype.render.call( this, ext );
  }
});
